import axios from "axios";
import React, { useEffect, useState } from "react";
import FormatDate from "../../formatdatetime";
import ViewTicket from "./ViewTicket";
import { baseurl } from "../../constant";
const ViewwholeTicket = (props) => {
  const [data, setdats] = useState();
  const [message, setmessage] = useState();
  const [image, setimage] = useState();
  const [data1, setdata1] = useState();
  const [active, setactive] = useState(1);

  const changecomponent = (change) => {
    setactive(change);
  };

  const token = localStorage.getItem("authToken");
  const getdata = async () => {
    const result = await axios.post(baseurl + "ticketDetailAuth", {
      token: token,
      id: props.id,
    });
    setdats(result.data.data);
  };
  useEffect(() => {
    getdata();
  }, [data1]);

  const ticketreply = async () => {
    const result = await axios.post(baseurl + "ticketReplyAuth", {
      token: token,
      ticket_id: props.id,
      message: message,
      image: image,
    });
    setdata1(result.data);
    setmessage();
    setimage();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64 = reader.result;
        const cleanBase64 = base64.split(",")[1];
        setimage(cleanBase64);
      };
    }
  };

  return (
    <>
      {active == 1 && (
        <div>
          {data1
            ? data1.status == 1 && (
                <p style={{ color: "green" }}>{data1.message}</p>
              )
            : ""}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <div className="row">
                <div className="col-sm-9">
                  <h4>
                    <b>{props.ticket_id}</b>
                  </h4>
                  <p style={{ margin: "0" }}>{props.itemsubject}</p>
                  <p>
                    <b>
                      <font color="green">{props.itemstarus}</font>
                    </b>
                  </p>
                </div>
                <div className="col-sm-3  text-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => changecomponent(2)}
                  >
                    <i className="fa fa-arrow-left"> Back</i>
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <form
                id="admin_profile"
                enctype="multipart/form-data"
                method="post"
                accept-charset="utf-8"
              />
              <input type="hidden" name="method" value="post" />
              <input type="hidden" value="https://www.payol.in/" id="siteUrl" />
              <input type="hidden" value="88" name="ticket_id" />
              <div className="row">
                <div className="col-sm-12">
                  <h4>Reply</h4>
                  <hr />
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>
                      <b>Message</b>
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      name="message"
                      id="message"
                      value={message}
                      onChange={(e) => setmessage(e.target.value)}
                    ></textarea>
                    {data1
                      ? data1.status == 0 && (
                          <p style={{ color: "red" }}>{data1.message}</p>
                        )
                      : ""}
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="form-group">
                    <label>
                      <b>Attachment</b>
                    </label>
                    <input
                      type="file"
                      name="attachment"
                      onChange={handleFileChange}
                    />
                    <p>
                      Allowed File Extenstions: .jpg, .png, .gif <br /> Max Size
                      Should be : 2MB
                    </p>
                  </div>
                </div>
                <div className="col-sm-2 mt-4">
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={ticketreply}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {data
                ? data.map((item) => (
                    <div className="col-sm-12 ticket-block">
                      <div className="ticket-top-head">
                        <div className="row">
                          <div className="col-sm-9">{item.member_name}</div>
                          <div className="col-sm-3 text-right">
                            {FormatDate(item.created)}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <p>{item.message}</p>
                          {item.attachment && (
                            <p
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                window.open(
                                  `https://payol.in/${item.attachment}`
                                )
                              }
                            >
                              <b>Attachment -</b>
                              View Attachment
                            </p>
                          )}
                          {item.attachment == null && (
                            <p>
                              <b>Attachment -</b>
                              no Attachment
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div>
      )}
      {active == 2 && <ViewTicket />}
    </>
  );
};

export default ViewwholeTicket;
